import { RouterStore } from 'mobx-router5';

// Types
export type IRouterStore = RouterStore;

// Store
export default RouterStore;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/RouterStore.ts